import {
  useCorrespondenceRouteWithUrlState,
  useCreateCorrespondenceThreadMutation,
  useMarkCorrespondencesAsReadMutation,
} from "toptaal-shared"
import { correspondenceQueryKeys } from "toptaal-shared"
import { getFilteredCorrespondence } from "toptaal-shared"
import {
  createFileRoute,
  useNavigate,
  useParams,
  useRouter,
  useSearch,
} from "@tanstack/react-router"
import {
  CorrespondenceEntityType,
  CorrespondenceOverview,
  CorrespondenceThread,
  createTableSearchSchema,
} from "toptaal-shared"
import { organizationUserCan } from "@/utils/organizationUserCan"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { useOrganizationUserQuery } from "@/api/queries/organizationUser/useOrganizationUserQuery"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/correspondentie/",
)({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "groups"),
  validateSearch: createTableSearchSchema(),
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useOrganizationUserQuery()

  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId/correspondentie/",
  })
  const searchParams = useSearch({
    from: "/beheer/groepen/$groupId/correspondentie/",
  })
  const navigate = useNavigate({
    from: "/beheer/groepen/$groupId/correspondentie/",
  })

  const entityType: CorrespondenceEntityType = "LessonGroup"
  const entityId = Number(groupId)

  const correspondenceProps = useCorrespondenceRouteWithUrlState({
    entityType,
    entityId,
    queryKey: correspondenceQueryKeys.group(entityId, entityType),
    queryFn: (filters) =>
      getFilteredCorrespondence({ entityId, entityType, filters }),
    useCreateMutation: useCreateCorrespondenceThreadMutation,
    searchParams,
    navigate,
    storageKey: `/beheer/groepen/${groupId}/correspondentie`,
  })

  const markAsReadMutation = useMarkCorrespondencesAsReadMutation({
    queryKey: correspondenceQueryKeys.group(entityId, entityType),
  })

  const handleNavigateToThread = (thread: CorrespondenceThread) => {
    if (thread.unreadCount > 0) {
      markAsReadMutation.mutate([thread.id])
    }

    router.navigate({
      to: "/beheer/groepen/$groupId/correspondentie/$threadId",
      replace: true,
      params: {
        threadId: String(thread.id),
        groupId,
      },
    })
  }

  return (
    <CorrespondenceOverview
      {...correspondenceProps}
      handleNavigateToThread={handleNavigateToThread}
      contextType={entityType}
      canCreateCorrespondence={organizationUserCan(
        "create",
        "groupCorrespondence",
      )}
      correspondencePermission={{
        root: "org",
        roles: user.roles,
        baseUserId: user.baseUserId,
      }}
    />
  )
}
